import React from 'react';
import { Typography } from '@mui/material';
import ButtonBox from '../../components/ButtonBox';
import { LOGIN_INITIALIZING } from '../../constants';
import '../../style/Login.css';

interface ActivateSuccessProps {
    setLoginPage: React.Dispatch<React.SetStateAction<string>>;
}

const ActivateSuccess: React.FC<ActivateSuccessProps> = ({ setLoginPage }) => {
    const handleActivateSuccess = () => {
        setLoginPage(LOGIN_INITIALIZING);
    };

    return (
        <>
            <Typography className='login_typography_title'>
                Start a FREE Trial
            </Typography>
            <Typography className='login_typography_content'>
                Start a 30-day free trail to access our features.
            </Typography>
            <ButtonBox
                text="Start my free trial"
                onClick={handleActivateSuccess}
            />
        </>
    );
};

export default ActivateSuccess;
